/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.controller('TrainingsCtrl', ['$scope', '$q', '$sce', '$filter', '$location', '$timeout', 'gtm', 'State', 'Trainings', 'TrainingEnums', 'CONFIG', function ($scope, $q, $sce, $filter, $location, $timeout, gtm, State, Trainings, Enums, CONFIG) {

        var state = new State();
        var data = {
            sorting: [
                { id: '-createdDate', name: CONFIG.app.locale["sortby_createdDate"] },
                { id: '-rating', name: CONFIG.app.locale["sortby_rating"] },
                { id: 'name', name: CONFIG.app.locale["sortby_name"] },
            ],
            paging: {
                items: 9, // x page
                page: 1
            },                    
            targets: [],
            levels: [],
            durations: [],
            coaches: [{ id: 0, name: CONFIG.app.locale["coach_community"] }, { id: 1, name: CONFIG.app.locale["coach_arena"] }, { id: 2, name: CONFIG.app.locale["coach_top"]}],
            tools: [],
            enablePublish: false,
            _searchTerm: ""
        };
        var model = {
            sorting: '-createdDate',
            filters: [],
            query: {},
            location: $location.path()
        };
        var trainings = { };

        var scope = {
            state: state,
            data: data,
            model: model,
            trainings: trainings,
            status: Enums.status,
            // methods
            setFilter: setFilter,
            removeFilter: removeFilter,
            all: all,
            latest: latest,
            top: top,
            target: target,
            exercise: exercise,
            tool: tool,
            coach: coach,
            publish: publish,
            me: me,
            suggested: suggested,
            swimlist: swimlist, 
        };
        
        angular.extend($scope, scope);

        //#region Search
        function initFilterData(items) {
            var targets = $filter('groupPropsByKeyValue')(items, 'target', 'id', 'name')
                .map(function (item) { return { id: item.key, name: item.value }; })
                .sort(function (a, b) { var a = a.name; var b = b.name; return (a < b) ? -1 : (a > b) ? 1 : 0; });                       
            angular.extend(data.targets, targets);

            var levels = $filter('groupPropsByKeyValue')(items, 'level', 'id', 'name')
                .map(function (item) { return { id: item.key, name: item.value }; })
                .sort(function (a, b) {var a = a.id; var b = b.id; return (a < b) ? -1 : (a > b) ? 1 : 0;});            
            angular.extend(data.levels, levels);

            var durations = $filter('groupPropsByKeyValue')(items, 'time', 'range', 'range')
                .map(function (item) {                    
                    var lookup = CONFIG.app.timeRange.filter(function (range) {return range.id === item.key;})[0];                                        
                    return { id: item.key, name: lookup.name, min: lookup.min };
                })
                .sort(function (a, b) { var a = a.min; var b = b.min; return (a < b) ? -1 : (a > b) ? 1 : 0; });
            angular.extend(data.durations, durations);

            /*
            var coaches = $filter('groupPropsByKeyValue')(items, 'coach', 'id', 'name')
                .map(function (item) { return { id: item.key, name: item.value }; })
                .sort(function (a, b) { var a = a.name; var b = b.name; return (a < b) ? -1 : (a > b) ? 1 : 0; });
            angular.extend(data.coaches, coaches);
            */

            var tools = $filter('groupPropsByKeyValue')(items, 'tools', 'id', 'name')
                .map(function (item) { return { id: item.key, name: item.value }; })
                .sort(function (a, b) { var a = a.name; var b = b.name; return (a < b) ? -1 : (a > b) ? 1 : 0; });
            angular.extend(data.tools, tools);
        }

        function setFilter(type) {            
            $timeout(function () {
                var filter = model[type];
                if (filter) {
                    filter.type = type;
                    var same = $filter('filter')(model.filters, function (item) { return item.type == type; });
                    if (same.length)
                        model.filters.splice(model.filters.indexOf(same[0]), 1);                    
                    model.filters.push(filter);
                }               
            });            
        }

        function removeFilter(item) { 
            model[item.type] = null;
            model.filters.splice(model.filters.indexOf(item), 1);            
        }

        function setQuery() {
            $timeout(function () {
                var query = {};
                angular.forEach(model.filters, function (filter) {
                    switch (filter.type) {
                        case 'time':
                            query[filter.type] = { range: filter.id };
                            break;
                        case 'coach':
                            query[filter.type] = { type: filter.id };
                            break;
                        case 'search':
                            //query["name"] = filter.name; //training title
                            if (filter.name != "" && filter.name != data._searchTerm) {
                                data._searchTerm = filter.name;
                                gtm.push({
                                    event: 'Search',
                                    type: 'Training',
                                    query: filter.name
                                });
                            }
                            query["$"] = filter.name; //all
                            break;
                        default:
                            query[filter.type] = { id: filter.id };
                    }
                    
                });
                model.query = query;
                data.paging.page = 1;
                //changeLocation();
                //console.log(query,model.filters)
            });
        }

        function changeLocation() {
            if (!window.btoa) return;

            if (model.filters && model.filters.length>0) {
                var _path = btoa(unescape(encodeURIComponent(angular.toJson(model.filters))));
                if ('/' + _path != $location.path())
                    $location.path(_path); //.replace();           
            } else {
                if ($location.path() != '' && $location.path() != '/')
                    $location.path(null);
            }            
        }

        //#region Watch
        $scope.$watchCollection('model.filters', function () {
            setQuery();
        })

        $scope.$watch('model.search.name', function () {
            setQuery();
        })

        $scope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
            model.location = $location.path();
        });

        if (window.atob) {
            $scope.$watch(function () { return $location.path() }, function (newLocation, oldLocation) {
                if (model.location === newLocation) {
                    if (newLocation != '') {                        
                        var hash = newLocation.substr(1);
                        try {
                            var filters = angular.fromJson(decodeURIComponent(escape(atob(hash))));
                            angular.forEach(filters, function (filter) {
                                model[filter.type] = filter;
                                setFilter(filter.type);
                            })      
                        } catch (ex) {
                        }
                    } 
                }
            });
        }
        //#endregion Watch

        //#endregion Search

        //#region Coach
        function publish(item) {            
            if (data.enablePublish && state.busy()) {                                                
                Trainings.publish(item.id).then(function (response) {                
                    state.success();                    
                    item.status = 1;
                }, function (error) {
                    state.error(error);
                });                
            }
        }
        //#endregion Coach
         
        //#region Api
        function all() {
            return Trainings.all().then(function (list) {
                trainings.list = list;
                initFilterData(trainings.list);
            });
        }

        function latest() {
            return Trainings.latest().then(function (list) { trainings.list = list; });
        }

        function top() {
            return Trainings.top().then(function (list) { trainings.list = list; });
        }

        function target(id) {
            return Trainings.target(id).then(function (list) { trainings.list = list; });
        }

        function exercise(id) {
            return Trainings.exercise(id).then(function (list) { trainings.list = list; });
        }

        function tool(id) {
            return Trainings.tool(id).then(function (list) { trainings.list = list; });
        }

        function coach(id) {
            return Trainings.coach(id).then(function (list) {
                trainings.listAllLanguages = list;
                trainings.list = $filter('filter')(list, function (item) { return item.language == CONFIG.app.lang.id; });;                
            });
        }

        function me() {
            return Trainings.me().then(function (list) { trainings.list = list; data.enablePublish = true;});
        }

        function suggested() {
            return Trainings.top().then(function (list) { trainings.list = list; });
        }

        function swimlist() {
            return Trainings.top().then(function (list) { trainings.list = list; });
        }
        //#endregion Api

    }]);

    app.controller('TrainingsDetailCtrl', ['$scope', '$filter', '$timeout', 'State', 'Upload', 'api', 'TrainingSet', 'TrainingEnums', 'CONFIG', function ($scope, $filter, $timeout, State, Upload, api, Set, Enums, CONFIG) {

        var state = new State();
        var data = {
            types: Enums.types,
            dryland: [],
            warmUp: new Set(Enums.types.WARM_UP),
            pre: [],
            mainSet: new Set(Enums.types.MAIN),
            after: [],
            coolDown: new Set(Enums.types.COOL_DOWN),
        };
        var model = {
            sets: [],
            tools: []
        };

        var scope = {
            state: state,
            data: data,
            model: model,
            load: load,
            toggleSet: toggleSet,
            onToggle: onToggle,
            getSetTypeName: getSetTypeName,
        };

        angular.extend($scope, scope);

        function Init() {

            api.data.training().then(function (response) {
                angular.extend(data, response.data);                
            });

            if (CONFIG.app.training) {
                angular.extend(model, CONFIG.app.training);
                updateData();
            }
        }

        Init();

        function load(id) {
            api.training.detail(id).then(function (response) {
                angular.extend(model, response.data);
                updateData();
            }); 
        }

        function updateData() {
            model.sets.filter(function (set) {
                switch (set.type) {
                    case Enums.types.DRYLAND:
                        data.dryland.push(set);
                        break;
                    case Enums.types.WARM_UP:
                        data.warmUp = set;
                        break;
                    case Enums.types.PRE:
                        data.pre.push(set);
                        break;
                    case Enums.types.MAIN:
                        //set.active = true;
                        data.mainSet = set;
                        break;
                    case Enums.types.AFTER:
                        data.after.push(set);
                        break;
                    case Enums.types.COOL_DOWN:
                        data.coolDown = set; 
                        break;
                }
            });
        }

        function getSetTypeName(type) {            
            return data.setTypes != null ? data.setTypes.filter(function (set) { return set.id == type })[0].name : '';
        }

        function addSetType(type) {
            switch (type) {
                case Enums.types.DRYLAND:
                    data.dryland.push(new Set(type));
                    break;
                case Enums.types.PRE:
                    data.pre.push(new Set(type));
                    break;
                case Enums.types.AFTER:
                    data.after.push(new Set(type));
                    break;
            }
            updateSets();
        }

        function toggleSet(item) {
            if (item.active) {
                item.active = false;
            } else {                   
                angular.forEach(model.sets, function (set) {
                    set.active = false;
                });
                item.active = true;     
            }
            // console.log('setActive', item);
        }

        function onToggle(e, item) {
            function hasParentClass(node, string) {
                var has = false;
                var classes = node.getAttribute('class');
                if (classes && classes.indexOf(string) !== -1) {
                    has = true;
                } else if (node.parentNode !== document) {
                    has = hasParentClass(node.parentNode, string);
                }
                return has;
            }
            if (!hasParentClass(e.target, 'training-drills')) {
                toggleSet(item);
                if (item.active) {
                    $timeout(function () {
                        var top = e.target.getBoundingClientRect().top;
                        // console.log('onScrollbarShouldScrollTo', top);
                        $scope.$root.$broadcast('onScrollbarShouldScrollTo', {
                            x: 0,
                            y: (top - 25),
                            selector: 'page',
                        });
                    }, 0);
                }
            }
        }

        function select(array, callback) {
            var r = array.filter(callback);
            return r.length ? r[0] : {};
        }        

    }]);

    app.controller('TrainingsCreateCtrl', ['$scope', '$filter', '$controller', '$timeout', 'State', 'Upload', 'api', 'gtm', 'Account', 'Trainings', 'TrainingSet', 'TrainingEnums', function ($scope, $filter, $controller, $timeout, State, Upload, api, gtm, Account, service, Set, Enums) {

        $controller('FormCtrl', {
            $scope: $scope
        });

        var state = new State();
        var statePublish = new State();
        var model = {
            tools: [], // contiene output tools allenamento 
            sets: [], // contiene output sets allenamento
        };

        var data = {
            types: Enums.types,
            dryland: [],
            warmUp: new Set(Enums.types.WARM_UP, true),
            pre: [],
            mainSet: new Set(Enums.types.MAIN, true),
            after: [],
            coolDown: new Set(Enums.types.COOL_DOWN, true),
        };

        var scope = {
            state: state,
            statePublish: statePublish,
            model: model,
            data: data,
            removeTool: removeTool,
            hasMinimumInfo: hasMinimumInfo,
            isComplete: isComplete,
            getSetTypeName: getSetTypeName,
            addSetType: addSetType,
            removeSet: removeSet,
            toggleSet: toggleSet,
            onToggle: onToggle,
            load: load,
            create: create,
            edit: edit,
            publish: publish,
            onUploadFileSelected: onUploadFileSelected,
        };

        angular.extend($scope, scope);

        function Init() {

            api.data.training().then(function (response) {
                angular.extend(data, response.data);                
            });

            data.minutes = new Array(24).fill().map(function (v, i) {
                var m = (i + 1) * 5;                                
                return {
                    id: m, name: m = (m / 60 >= 1 ? (parseInt(m / 60) + "h") : "") + (m % 60 > 0 ? m % 60 + "'" : "")
                };
            });

            data.seconds = new Array(24).fill().map(function (v, i) {
                var m = i * 5;
                return {
                    id: m, name: m = (m / 60 >= 1 ? (parseInt(m / 60) + "'") : "") + (m % 60 > 0 ? m % 60 + "\"" : "") };

            });

            data.distances = new Array(60).fill().map(function (v, i) {
                var d = (i + 1) * 25;                
                return { id: d, name: d + "m", show: (d <= 400 || (d <= 800 && d % 50 === 0) || (d <= 1500 && d % 100 === 0)) };
            });

            data.repetitions = new Array(16).fill().map(function (v, i) {
                var r = i + 1;
                return { id: r, name: r };
            });

            updateSets();
        }

        Init();

        function load(id) {
            service.detail(id).then(function (training) {
                angular.extend(model, training);         
                updateData();  
                $timeout(function () {
                    if (model.icon) {
                        var picture = { url: '/media/immagini/' + model.icon, alreadyUploaded: true };
                        data.pictures.push(picture);
                        model.uploadPicture = picture;
                    }                        
                }, 500);                    
            }, function (error) {                
            });
        }

        function removeTool(item) {
            model.tools.splice(model.tools.indexOf(item),1);
        }

        function hasMinimumInfo() {
            return model.name && model.abstract;
        }

        function isComplete(form) {
            return hasMinimumInfo() && form.$valid; // && model.sets.length > 0;
        }

        function updateData() {
            model.sets.filter(function (set) {
                switch (set.type) {
                    case Enums.types.DRYLAND:
                        data.dryland.push(set);
                        break;
                    case Enums.types.WARM_UP:
                        data.warmUp = set;
                        break;
                    case Enums.types.PRE:
                        data.pre.push(set);
                        break;
                    case Enums.types.MAIN:
                        set.active = true;
                        data.mainSet = set;
                        break;
                    case Enums.types.AFTER:
                        data.after.push(set);
                        break;
                    case Enums.types.COOL_DOWN:
                        data.coolDown = set;
                        break;
                }
            });
        }

        function getSetTypeName(type) {
            return data.setTypes != null ? data.setTypes.filter(function (set) { return set.id == type })[0].name : '';
        }

        function addSetType(type) {
            switch (type) {
                case Enums.types.DRYLAND:
                    data.dryland.push(new Set(type));
                    break;
                case Enums.types.PRE:
                    data.pre.push(new Set(type));
                    break;
                case Enums.types.AFTER:
                    data.after.push(new Set(type));
                    break;
            }
            updateSets();
        }

        function removeSet(item) {
            switch (item.type) {
                case Enums.types.DRYLAND:
                    data.dryland.splice(data.dryland.indexOf(item), 1);
                    break;
                case Enums.types.PRE:
                    data.pre.splice(data.pre.indexOf(item), 1);
                    break;
                case Enums.types.AFTER:
                    data.after.splice(data.after.indexOf(item), 1);
                    break;
            }
            updateSets();
        }

        function updateSets() {
            var sets = [];
            Array.prototype.push.apply(sets, data.dryland);
            Array.prototype.push.apply(sets, [data.warmUp]);
            Array.prototype.push.apply(sets, data.pre);
            Array.prototype.push.apply(sets, [data.mainSet]);
            Array.prototype.push.apply(sets, data.after);
            Array.prototype.push.apply(sets, [data.coolDown]);
            model.sets = sets;
        }

        function toggleSet(item) {
            if (item.active) {
                item.active = false;
            } else {
                angular.forEach(model.sets, function (set) {
                    set.active = false;
                });
                item.active = true;
            }            
            //console.log('setActive', item);
        }

        function onToggle(e, item) {
            function hasParentClass(node, string) {
                var has = false;
                var classes = node.getAttribute('class');
                if (classes && classes.indexOf(string) !== -1) {
                    has = true;
                } else if (node.parentNode !== document) {
                    has = hasParentClass(node.parentNode, string);
                }
                return has;
            }
            if (!hasParentClass(e.target, 'training-drills')) {
                toggleSet(item);
                if (item.active) {
                    $timeout(function () {
                        var top = e.target.getBoundingClientRect().top;
                        $scope.$root.$broadcast('onScrollbarShouldScrollTo', {
                            x: 0,
                            y: (top - 25),
                            selector: 'page',
                        });
                    }, 0);
                }
            }
        }

        function create() {
            if (state.busy()) {                
                service.save(model).then(function (item) {                    
                    gtmPush('Crea allenamento', item);
                    state.success();                    
                }, function (error) {
                    state.error(error);
                });
            }            
        }

        function edit() {
            if (state.busy()) {
                service.edit(model).then(function (item) {
                    gtmPush('Modifica allenamento', item);
                    state.success();
                }, function (error) {
                    state.error(error);
                });
            }
        }

        function publish() {
            if (statePublish.busy()) {
                service.publish(model.id).then(function (item) {
                    gtmPush('Pubblica allenamento', item);
                    statePublish.success();
                }, function (error) {
                    statePublish.error(error);
                });
            }
        }

        function gtmPush(event, item) {                   
            gtm.push({
                event: event,
                user: item.coach.id,
                user_type: 2,
                allenamento: item.id
            })
        }

        function onUploadFileSelected(file, newFiles) {
            if (!file) {
                return;
            }
            Array.isArray(file) ? file = file[0] : null;
            data.base64 = null;
            Upload.resize(file, 1260, 540, .9, 'image/jpeg', null, true).then(function (resized) {
                Upload.dataUrl(resized, true).then(function (url) {
                    data.base64 = url;
                    model.uploadPicture = {
                        base64: data.base64,
                    };
                });
            });
        }

        function select(array, callback) {
            var r = array.filter(callback);
            return r.length ? r[0] : {};
        }

    }]);

    app.service('Trainings', ['$q', 'api', function ($q, api) {

        var service = {

            all: function () {
                var deferred = $q.defer();
                api.training.all().then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            latest: function () {
                var deferred = $q.defer();
                api.training.latest().then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            top: function () {
                var deferred = $q.defer();
                api.training.top().then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            target: function (id) {
                var deferred = $q.defer();
                api.training.target(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            exercise: function (id) {
                var deferred = $q.defer();
                api.training.exercise(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            tool: function (id) {
                var deferred = $q.defer();
                api.training.tool(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            coach: function (id) {
                var deferred = $q.defer();
                api.training.coach(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            me: function () {
                var deferred = $q.defer();
                api.training.me().then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            suggested: function () {
                var deferred = $q.defer();
                api.training.suggested().then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            swimlist: function () {
                var deferred = $q.defer();
                api.training.swimlist().then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            detail: function (id) {
                var deferred = $q.defer();
                api.training.detail(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            save: function (model) {
                var deferred = $q.defer();
                api.training.save(model).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            edit: function (model) {
                var deferred = $q.defer();
                api.training.edit(model).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            },
            publish: function (id) {
                var deferred = $q.defer();
                api.training.publish(id).then(function (response) {
                    deferred.resolve(response.data || []);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            }
        };
        return service;


    }]);

    app.factory('TrainingSet', ['TrainingDrill', 'TrainingEnums', function (TrainingDrill, Enums) {

        function TrainingSet(type,mandatory) {
            this.type = type;
            this.mandatory = mandatory || false;
            this.drills = [new TrainingDrill()];            
        }

        var statics = {
            types: Enums.types,
        };

        var publics = {

        };

        angular.extend(TrainingSet, statics);
        angular.extend(TrainingSet.prototype, publics);

        return TrainingSet;
    }]);

    app.factory('TrainingDrill', [function () {
        function TrainingDrill() {            
        }

        var statics = {};

        var publics = {};

        angular.extend(TrainingDrill, statics);
        angular.extend(TrainingDrill.prototype, publics);

        return TrainingDrill;
    }]);

    app.constant('TrainingEnums', {
        types: {
            DRYLAND: 1,
            WARM_UP: 2,
            PRE: 3,
            MAIN: 4,
            AFTER: 5,
            COOL_DOWN: 6,
        },
        status: {            
            SAVED: 0,
            PUBLISHINGREQUEST: 1,
            APPROVED: 2,        
        }        
    });

    app.directive('trainingDrills', ['TrainingDrill', '$timeout', function (TrainingDrill, $timeout) {
        return {
            priority: 1001,
            restrict: 'A',
            scope: {
                set: '=trainingDrills',
                data: '=',
            },
            templateUrl: function (element, attributes) {
                return attributes.template || 'partials/training/drills';
            },
            /*
            transclude: 'element',
            replace: true,
            */
            link: function (scope, element, attributes, controller) {                
                var set = scope.set;
                // console.log('trainingDrills', set);

                var publics = {
                    addDrill: addDrill,
                    removeDrill: removeDrill,
                    onSelectDrill: onSelectDrill,
                };

                angular.extend(scope, publics);

                function addDrill() {                    
                    set.drills.push(new TrainingDrill());                    
                }

                function removeDrill(item, e) {                    
                    set.drills.splice(set.drills.indexOf(item), 1);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }

                function onSelectDrill(item) {
                    $timeout(function () {
                        item.name = item.exercise.name || item.name;
                    });
                }
            }
        };
    }]);

}());